import React from 'react';

import Nav from './components/Nav';
import NavDropdown from './components/NavDropdown';

const HeaderNav = (props) => {
    return (
        <div className="flex items-center space-x-10">
            <NavDropdown title="My Devices">
                <Nav
                    isDropdownItem={true}
                    name="Register Product"
                    route="/member/register-product"
                    goToPage={props.goToPage}
                    icon={
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        ></path>
                    }
                />
                <Nav
                    isDropdownItem={true}
                    name="View Warranty"
                    route="/member/view-warranty"
                    goToPage={props.goToPage}
                    icon={
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                        ></path>
                    }
                />
            </NavDropdown>

            <NavDropdown title="Service & Support">
                <Nav
                    isDropdownItem={true}
                    name="Schedule Appointment"
                    route="/member/book-appointment"
                    goToPage={props.goToPage}
                    icon={
                        <>
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M8 7V3a1 1 0 011-1h6a1 1 0 011 1v4h3a1 1 0 011 1v1H5V8a1 1 0 011-1h2z"
                            ></path>
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M5 10v9a1 1 0 001 1h12a1 1 0 001-1v-9"
                            ></path>
                        </>
                    }
                />
                <Nav
                    isDropdownItem={true}
                    name="View Appointments"
                    route="/member/view-booking-appointment"
                    goToPage={props.goToPage}
                    icon={
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                        ></path>
                    }
                />
                <Nav
                    isDropdownItem={true}
                    name="Service History"
                    route="/member/view-service-case"
                    goToPage={props.goToPage}
                    icon={
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        ></path>
                    }
                />
            </NavDropdown>

            {/*<NavDropdown title="Loyalty">*/}
            {/*    <Nav*/}
            {/*        isDropdownItem={true}*/}
            {/*        name="Rewards Catalog"*/}
            {/*        route="/member/rewards"*/}
            {/*        goToPage={props.goToPage}*/}
            {/*        icon={*/}
            {/*            <path*/}
            {/*                strokeLinecap="round"*/}
            {/*                strokeLinejoin="round"*/}
            {/*                strokeWidth="2"*/}
            {/*                d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"*/}
            {/*            ></path>*/}
            {/*        }*/}
            {/*    />*/}
            {/*</NavDropdown>*/}
        </div>
    );
};

export default HeaderNav;
